;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["syncbal"],
  data: function data() {
    return {
      bank_accounts: [],
      selectedAccount: null,
      withdrawTo: null,
      mpesaAccount: null,
      withdrawal_amount: null,
      merchant_id: null,
      current_account_balance: 0,
      api_token: null,
      con_key: null,
      con_secret: null
    };
  },

  watch: {
    syncbal: function syncbal(val) {
      this.current_account_balance = val;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.current_account_balance = this.$attrs["currentaccountbalance"];
    this.merchant_id = this.$attrs["merchantid"];
    this.con_key = this.$attrs["conkey"];
    this.con_secret = this.$attrs["consecret"];

    $("#withdrawalModal").on("hidden.bs.modal", function () {
      _this.withdrawal_amount = null;
    });
    $("#withdrawalModal").on("shown.bs.modal", function () {
      _this.getOauthToken();
    });
  },

  methods: {
    getOauthToken: function getOauthToken() {
      var _this2 = this;

      var url = "/api/oauth/generate/token";
      var payload = {
        secret: this.con_secret,
        key: this.con_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this2.api_token = response.data.token;
        _this2.loadBankAccounts();
      }).catch(function (error) {}).then(function () {});
    },
    loadBankAccounts: function loadBankAccounts() {
      var _this3 = this;

      var url = "/api/banks/accounts/filtered?merchant_ids=[" + this.merchant_id + "]";
      var api_headers = { Authorization: "Bearer " + this.api_token };
      Vue.axios.get(url, {
        headers: api_headers
      }).then(function (response) {
        _this3.bank_accounts = response.data.bank_accounts;
      }).catch(function (error) {}).then(function () {});
    },
    validateWithdrawal: function validateWithdrawal() {
      if (!this.selectedAccount && !this.mpesaAccount) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter a valid Safaricom Phone Number or Chose an account number"
        });
        return;
      }

      if (!this.selectedAccount) {
        var re = /^(25471|25470|25472|25479|25474)\d{7}$/;
        if (!re.test(this.mpesaAccount)) {
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "Please enter a valid Safaricom Phone Number"
          });
          return;
        }
      }
      if (this.withdrawal_amount == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter an amount!"
        });
        return false;
      }
      if (parseFloat(this.withdrawal_amount) <= 0) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter an amount not less than 1 !"
        });
        return false;
      }

      if (parseFloat(this.withdrawal_amount) > parseFloat(this.current_account_balance)) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter an amount not greater than " + this.current_account_balance
        });
        return false;
      }

      if (this.selectedAccount == null && this.mpesaAccount == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please select either a bank account or mobile money account !"
        });
        return false;
      }

      this.executeWithdrawal();
    },
    resetAccounts: function resetAccounts() {
      this.selectedAccount = null;
      this.mpesaAccount = null;
    },
    resetWithdrawalForm: function resetWithdrawalForm() {
      this.selectedAccount = null;
      this.mpesaAccount = null;
      this.withdrawal_amount = null;
      this.withdrawTo = null;
    },
    executeWithdrawal: function executeWithdrawal() {
      var _this4 = this;

      var bankAccountId = null;
      var gateway = "mpesa-b2c";
      if (this.selectedAccount != null) {
        bankAccountId = this.selectedAccount.id;
        gateway = "mpesa";
      }
      var params = {
        bank_account_id: bankAccountId,
        destination: this.mpesaAccount,
        amount: this.withdrawal_amount,
        account_id: this.account_id,
        gateway: gateway
      };

      this.resetWithdrawalForm();
      _sweetalert2.default.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, withdraw funds"
      }).then(function (result) {
        if (result.value) {
          _this4.authorizeWithdrawal(params);
        }
      });
    },
    authorizeWithdrawal: function authorizeWithdrawal(params) {
      var _this5 = this;

      var url = "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this5.api_token = response.data.token;
        _this5._make_withdrawal(_this5.api_token, params);
      }).catch(function (error) {}).then(function () {});
    },
    _make_withdrawal: function _make_withdrawal(token, params) {
      var urlIs = "/api/payment/withdraw";
      var api_headers = {
        Authorization: "Bearer " + token
      };
      Vue.axios.post(urlIs, params, {
        headers: api_headers
      }).then(function (response) {
        if (response.data.status == 422) {
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!"
          });
        } else {
          $("#withdrawalModal .close").click();
          _sweetalert2.default.fire({
            position: "top-end",
            icon: "success",
            title: "Withdrawal Inititated !",
            showConfirmButton: false,
            timer: 2500
          });
        }
      }).catch(function (error) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!"
        });
      }).then(function () {});
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"withdrawalModal","tabindex":"-1","role":"dialog","aria-labelledby":"withdrawalModal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('form',{attrs:{"id":"frmWIthdraw","name":"frmWIthdraw","onsubmit":"return false;"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"md-form mb-5"},[_c('label',{attrs:{"data-error":"wrong","data-success":"right","for":"amount"}},[_vm._v("Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.withdrawal_amount),expression:"withdrawal_amount"}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":_vm.current_account_balance},domProps:{"value":(_vm.withdrawal_amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.withdrawal_amount=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right","for":"amount"}},[_vm._v("Withdraw To")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.withdrawTo),expression:"withdrawTo"}],staticClass:"form-control list-gateways",attrs:{"tabindex":"-1","aria-hidden":"true"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.withdrawTo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.resetAccounts]}},[_c('option'),_vm._v(" "),_c('option',{attrs:{"value":"MPESA"}},[_vm._v("DIRECT TO MPESA")]),_vm._v(" "),_c('option',{attrs:{"value":"BANK"}},[_vm._v("DIRECT TO BANK")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right","for":"amount"}},[_vm._v("Account")]),_vm._v(" "),(_vm.withdrawTo === 'BANK')?_c('v-select',{attrs:{"label":"account_number","options":_vm.bank_accounts,"reduce":function (name) { return name.id; }},model:{value:(_vm.selectedAccount),callback:function ($$v) {_vm.selectedAccount=$$v},expression:"selectedAccount"}}):_vm._e(),_vm._v(" "),(_vm.withdrawTo === 'MPESA')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mpesaAccount),expression:"mpesaAccount"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter Mpesa Number e.g 254711WWWPPP","max":"12"},domProps:{"value":(_vm.mpesaAccount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mpesaAccount=$event.target.value}}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n            Close\n          ")]),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Withdraw"},on:{"click":_vm.validateWithdrawal}})])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Withdraw Funds")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e292d6b4", __vue__options__)
  } else {
    hotAPI.reload("data-v-e292d6b4", __vue__options__)
  }
})()}